module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_sunshouse_02-8c2c89ad8dd48584e83371033f93211c.png";